import React from 'react'
import { Link } from "react-router-dom";
import HomeAbout from '../home/HomeAbout';
import WhyChoose from '../home/WhyChoose';
import SuccessfulProjects from '../home/SuccessfulProjects';
import WorkingProcess from '../home/WorkingProcess';
import HomeTestimonials from '../home/HomeTestimonials';
import OurCertificate from '../home/OurCertificate';


const About = () => {
    return (
        <>

            <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
                <div className="breadcrumb_overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="breadcrumb_text">
                                    <h1>About us</h1>
                                    <ul className="d-flex flex-wrap">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/">About us</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <HomeAbout />
            <WhyChoose />
            <SuccessfulProjects />
            <WorkingProcess />
            {/* <OurCertificate /> */}
            <HomeTestimonials />


        </>
    )
}

export default About